module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_4_4.4ff938d6.png";